// extracted by mini-css-extract-plugin
module.exports = {"modal__header":"modal_modal__header__3bLxh","modal__close":"modal_modal__close__gafUt","modal__form":"modal_modal__form__10KWx","modal__logo":"modal_modal__logo__2PJbJ"};